import BaseModal from "@reusables/Modals/BaseModal";
import UIButton from "@reusables/UIButton";
import { useTranslation } from "react-i18next";

interface OfferActivationModalProps {
    isOpen: boolean;
    isLoading?: boolean;
    customer?: string;
    paymentTerms?: string;
    deliveryTerms?: string;
    onClose: () => void;
    onConfirm: () => void;
}

export default function OfferActivationModal({
    isOpen,
    isLoading,
    customer,
    paymentTerms,
    deliveryTerms,
    onClose,
    onConfirm,
}: OfferActivationModalProps) {
    const { t } = useTranslation("", { keyPrefix: "sales.orders.general.modals.offerActivation" });

    return (
        <BaseModal
            isOpen={isOpen}
            onClose={onClose}
            width={473}
            padding="56px"
            isLoading={isLoading}
        >
            <div className="space-y-[32px]">
                <div className="text-xl font-semibold text-center text-accent">{t("heading")}</div>

                <div className="space-y-[8px] text-accent text-[16px]">
                    <div className="flex items-start gap-[8px]">
                        <span className="font-light">{t("fields.customer")}</span>
                        <span className="font-semibold">{customer || "-"}</span>
                    </div>
                    <div className="flex items-start gap-[8px]">
                        <span className="font-light">{t("fields.paymentTerms")}</span>
                        <span className="font-semibold">{paymentTerms || "-"}</span>
                    </div>
                    <div className="flex items-start gap-[8px]">
                        <span className="font-light">{t("fields.deliveryTerms")}</span>
                        <span className="font-semibold">{deliveryTerms || "-"}</span>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-[16px]">
                    <UIButton type="button" size="lg" variant="outline" onClick={onClose}>
                        <span>{t("buttons.cancel")}</span>
                    </UIButton>
                    <UIButton type="button" size="lg" onClick={onConfirm}>
                        <span>{t("buttons.activate")}</span>
                    </UIButton>
                </div>
            </div>
        </BaseModal>
    );
}
